import styles from "../../../../styles.module.scss";
import { MergedColumnType } from "../../../types";

import { createColumn } from "../../utils";
//UI
import type { ColumnType, ColumnsType } from "antd/es/table";
import Checkbox from "antd/lib/checkbox";

import { FilterFilled } from "@ant-design/icons";
import classNames from "classnames";

export const professionClassifierColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>
) => [
  createColumn(intl("name"), "Name", undefined, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
  createColumn(intl("code-kp"), "KP", 200, getColumnSearchProps, (a, b) =>
    a.KP?.localeCompare(b.KP)
  ),
  createColumn(
    intl("code-okp"),
    "OKP",
    200,
    getColumnSearchProps,
    (a, b) => a.OKP?.localeCompare(b.OKP)
  ),
  createColumn(
    intl("code-etks"),
    "ETKS",
    200,
    getColumnSearchProps,
    (a, b) => a.ETKS?.localeCompare(b.ETKS)
  ),
];

export const jobCategoriesColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>
) => [
  createColumn(intl("code"), "Code", 150, getColumnSearchProps, (a, b) =>
    a.Code?.localeCompare(b.Code)
  ),
  createColumn(intl("name"), "Name", undefined, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
];

export const typesOfStructuralUnitColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>
) => [
    createColumn(intl("code"), "Code", 150, getColumnSearchProps, (a, b) =>
    a.Code?.localeCompare(b.Code)
  ),
  createColumn(intl("name"), "Name", 700, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
  createColumn(
    intl("notes"),
    "Notes",
    undefined,
    getColumnSearchProps,
    (a, b) => a.Notes?.localeCompare(b.Notes)
  ),
];

export const employeesColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(intl("fio"), "fio", 300, getColumnSearchProps, (a, b) =>
    a.fio?.localeCompare(b.fio)
  ),
  createColumn(
    intl("for-envelopes"),
    "fio_dp",
    200,
    getColumnSearchProps,
    (a, b) => a.fio_dp?.localeCompare(b.fio_dp)
  ),
  createColumn(intl("position"), "posada", 300, getColumnSearchProps, (a, b) =>
    a.posada?.localeCompare(b.posada)
  ),
  {
    title: intl("head"),
    dataIndex: "IS_KERIVNIK",
    key: "IS_KERIVNIK",
    width: 150,
    align: "center" as const,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IS_KERIVNIK}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IS_KERIVNIK === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("right-control"),
    dataIndex: "IS_CONTROL",
    key: "IS_CONTROL",
    width: 150,
    align: "center" as const,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IS_CONTROL}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IS_CONTROL === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("structural-unit"),
    "name_otdel",
    300,
    getColumnSearchProps,
    (a, b) => a.name_otdel?.localeCompare(b.name_otdel)
  ),
  createColumn(
    intl("work-phone"),
    "WORK_TEL",
    200,
    getColumnSearchProps,
    (a, b) => a.WORK_TEL?.localeCompare(b.WORK_TEL)
  ),
  createColumn(intl("fax"), "WORK_FAX", 200, getColumnSearchProps, (a, b) =>
    a.WORK_FAX?.localeCompare(b.WORK_FAX)
  ),
  createColumn(
    intl("mobile-phone"),
    "MOBILE_TEL",
    200,
    getColumnSearchProps,
    (a, b) => a.MOBILE_TEL?.localeCompare(b.MOBILE_TEL)
  ),
  createColumn(
    intl("email"),
    "WORK_E_MAIL",
    200,
    getColumnSearchProps,
    (a, b) => a.WORK_E_MAIL?.localeCompare(b.WORK_E_MAIL)
  ),
  createColumn(
    intl("no-cabinet"),
    "N_ROOM",
    150,
    getColumnSearchProps,
    (a, b) => a.N_ROOM?.localeCompare(b.N_ROOM)
  ),
  {
    title: intl("released"),
    dataIndex: "is_uvolen",
    key: "is_uvolen",
    width: 150,
    align: "center" as const,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.is_uvolen}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.is_uvolen === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
];

export const structuralUnitsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  {
    title: intl("structural-unit"),
    children: [
      createColumn(intl("code"), "Code", 100, getColumnSearchProps, (a, b) =>
        a.Code?.localeCompare(b.Code)
      ),
      createColumn(
        intl("type2"),
        "name_subdivision",
        200,
        getColumnSearchProps,
        (a, b) => a.name_subdivision?.localeCompare(b.name_subdivision)
      ),
      createColumn(
        intl("full-name"),
        "Name",
        500,
        getColumnSearchProps,
        (a, b) => a.Name?.localeCompare(b.Name)
      ),
      createColumn(
        intl("short-name"),
        "name_otdel_short",
        200,
        getColumnSearchProps,
        (a, b) => a.name_otdel_short?.localeCompare(b.name_otdel_short)
      ),
      createColumn(
        intl("refers-to"),
        "NameParent",
        300,
        getColumnSearchProps,
        (a, b) => a.NameParent?.localeCompare(b.NameParent)
      ),
    ],
  },
  {
    title: intl("reorganization"),
    children: [
      createColumn(
        intl("reorganized-into"),
        "NameReorg",
        300,
        getColumnSearchProps,
        (a, b) => a.NameReorg?.localeCompare(b.NameReorg)
      ),
    ],
  },
  {
    title: intl("other"),
    children: [
      createColumn(intl("notes"), "prim", 300, getColumnSearchProps, (a, b) =>
        a.prim?.localeCompare(b.prim)
      ),
      {
        title: intl("liquidated"),
        dataIndex: "is_liquidated",
        key: "is_liquidated",
        align: "center" as const,
        width: 120,
        render: (_: any, record: MergedColumnType) => (
          <Checkbox
            className={styles["checkbox"]}
            checked={!!record.is_liquidated}
            disabled
          />
        ),
        filters,
        onFilter: (value: any, record: MergedColumnType) =>
          !!record.is_liquidated === value,
        filterIcon: (filtered: boolean) => (
          <FilterFilled
            className={classNames(styles["filter-icon"], {
              [styles["filter-icon--active"]]: filtered,
            })}
          />
        ),
      },
    ],
  },
];

export const positionsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>
) => [
  {
    title: intl("position"),
    children: [
      createColumn(
        intl("category"),
        "KATEGORIA",
        250,
        getColumnSearchProps,
        (a, b) => a.KATEGORIA?.localeCompare(b.KATEGORIA)
      ),
      createColumn(intl("code-kp"), "Code", 150, getColumnSearchProps, (a, b) =>
        a.Code?.localeCompare(b.Code)
      ),
      createColumn(
        intl("profession-classifier"),
        "NameProf",
        300,
        getColumnSearchProps,
        (a, b) => a.NameProf?.localeCompare(b.NameProf)
      ),
      createColumn(
        intl("position"),
        "Name",
        300,
        getColumnSearchProps,
        (a, b) => a.Name?.localeCompare(b.Name)
      ),
    ],
  },
  {
    title: intl("other"),
    children: [
      createColumn(
        intl("description"),
        "OPISAN",
        300,
        getColumnSearchProps,
        (a, b) => a.OPISAN?.localeCompare(b.OPISAN)
      ),
    ],
  },
];

const BOOL_W = 120; // px

function defaultBoolFilters(intl: (id: string) => string) {
  return [
    { text: intl("yes"), value: true },
    { text: intl("no"), value: false },
  ] as { text: string; value: boolean }[];
}

function boolCol(
  title: string,
  dataIndex: keyof MergedColumnType,
  filters?: { text: string; value: boolean }[],
): ColumnType<MergedColumnType> {
  return {
    title,
    dataIndex,
    key: String(dataIndex),
    align: "center",
    width: BOOL_W,
    // не даємо заголовку переноситись (інакше колонки «розповзатимуться»)
    onHeaderCell: () => ({ style: { whiteSpace: "nowrap" } }),
    // опційно: ellipsis для комірки (зазвичай для чекбокса не треба)
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox className={styles["checkbox"]} checked={!!record[dataIndex]} disabled />
    ),
    // фільтри, якщо потрібні:
    filters,
    onFilter: (value: any, record: MergedColumnType) => !!record[dataIndex] === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  };
}

export const employeesAndContactPersonsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (dataIndex: keyof MergedColumnType) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => {
  const boolFilters = filters ?? defaultBoolFilters(intl);
  return [
  createColumn(
    intl("full-name-pib"),
    "contact_person",
    300,
    getColumnSearchProps,
    (a, b) => a.contact_person?.localeCompare(b.contact_person)
  ),
  createColumn(
    intl("organization-structural-division"),
    "name_firm_plat",
    300,
    getColumnSearchProps,
    (a, b) => a.name_firm_plat?.localeCompare(b.name_firm_plat)
  ),
  createColumn(intl("position"), "posada", 300, getColumnSearchProps, (a, b) =>
    a.posada?.localeCompare(b.posada)
  ),
  boolCol(intl("head"), "is_kerivnik", boolFilters),
  boolCol(intl("has-the-right-to-control"), "is_control", boolFilters),
  boolCol(intl("employee"), "is_clerk", boolFilters),
  boolCol(intl("liberated"), "is_uvolen", boolFilters),
] as ColumnsType<MergedColumnType>;
};

export const departmentalJournalsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(intl("code"), "Code", 100, getColumnSearchProps, (a, b) =>
    a.Code?.localeCompare(b.Code)
  ),
  createColumn(intl("name"), "Name", 300, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
  createColumn(
    intl("notes"),
    "Description",
    300,
    getColumnSearchProps,
    (a, b) => a.Description?.localeCompare(b.Description)
  ),
  createColumn(
    intl("office-department"),
    "name_otdel",
    300,
    getColumnSearchProps,
    (a, b) => a.name_otdel?.localeCompare(b.name_otdel)
  ),
  // createColumn(intl("user"), "name_user", 150, getColumnSearchProps, (a, b) =>
  //   a.name_user?.localeCompare(b.name_user)
  // ),
  {
    title: intl("by-default-at-registration"),
    dataIndex: "isActiveForTransfer",
    key: "isActiveForTransfer",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isActiveForTransfer}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isActiveForTransfer === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("incoming2"),
    dataIndex: "IsConstTypeDoc_1",
    key: "IsConstTypeDoc_1",
    align: "center" as const,
    width: 130,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsConstTypeDoc_1}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsConstTypeDoc_1 === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("outgoing"),
    dataIndex: "IsConstTypeDoc_2",
    key: "IsConstTypeDoc_2",
    align: "center" as const,
    width: 130,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsConstTypeDoc_2}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsConstTypeDoc_2 === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("internal2"),
    dataIndex: "IsConstTypeDoc_3",
    key: "IsConstTypeDoc_3",
    align: "center" as const,
    width: 130,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsConstTypeDoc_3}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsConstTypeDoc_3 === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("citizens-appeal"),
    dataIndex: "IsConstTypeDoc_4",
    key: "IsConstTypeDoc_4",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsConstTypeDoc_4}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsConstTypeDoc_4 === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("do-not-display-in-the-general-register"),
    dataIndex: "IsNotVisibleGeneralList",
    key: "IsNotVisibleGeneralList",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsNotVisibleGeneralList}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsNotVisibleGeneralList === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("re-registration-from-the-asn"),
    dataIndex: "IsVisa",
    key: "IsVisa",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsVisa}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsVisa === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("int-performe-cod-i-th-as-database"),
    "VisaExecutors_id",
    150,
    getColumnSearchProps,
    (a, b) => a.VisaExecutors_id - b.VisaExecutors_id
  ),
  createColumn(
    intl("start-re-registration-with"),
    "VisaDateStart",
    150,
    getColumnSearchProps,
    (a, b) => a.VisaDateStart?.localeCompare(b.VisaDateStart),
    (date: string) => date && new Date(date).toLocaleDateString("uk-UA")
  ),
  {
    title: intl("re-registration-from-citizens-requests"),
    dataIndex: "IsZvern",
    key: "IsZvern",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.IsZvern}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.IsZvern === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("include-the-first-letter-in-the-zg-index"),
    dataIndex: "isIndexZ_FirstLitera",
    key: "isIndexZ_FirstLitera",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isIndexZ_FirstLitera}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isIndexZ_FirstLitera === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("include-the-application-form-in-the-zg-index"),
    dataIndex: "isIndexZ_FormComplaint",
    key: "isIndexZ_FormComplaint",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isIndexZ_FormComplaint}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isIndexZ_FormComplaint === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  {
    title: intl("include-journal-code-in-the-zg-index"),
    dataIndex: "isIndexZ_CodeNomenklature",
    key: "isIndexZ_CodeNomenklature",
    align: "center" as const,
    width: 130,
    ellipsis: true,
    render: (_: any, record: MergedColumnType) => (
      <Checkbox
        className={styles["checkbox"]}
        checked={!!record.isIndexZ_CodeNomenklature}
        disabled
      />
    ),
    filters,
    onFilter: (value: any, record: MergedColumnType) =>
      !!record.isIndexZ_CodeNomenklature === value,
    filterIcon: (filtered: boolean) => (
      <FilterFilled
        className={classNames(styles["filter-icon"], {
          [styles["filter-icon--active"]]: filtered,
        })}
      />
    ),
  },
  createColumn(
    intl("incoming-order"),
    "OrderByEnterDoc",
    150,
    getColumnSearchProps,
    (a, b) => a.OrderByEnterDoc - b.OrderByEnterDoc
  ),
  createColumn(
    intl("outgoing-order"),
    "OrderByTurndoc",
    150,
    getColumnSearchProps,
    (a, b) => a.OrderByTurndoc - b.OrderByTurndoc
  ),
  createColumn(
    intl("internal-order"),
    "OrderByInterDoc",
    150,
    getColumnSearchProps,
    (a, b) => a.OrderByInterDoc - b.OrderByInterDoc
  ),
];

export const groupsOfCorrespondentsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[]
) => [
  createColumn(intl("code"), "Code", 150, getColumnSearchProps, (a, b) =>
    a.Code?.localeCompare(b.Code)
  ),
  createColumn(intl("name"), "Name", 500, getColumnSearchProps, (a, b) =>
    a.Name?.localeCompare(b.Name)
  ),
  createColumn(
    intl("office-department"),
    "name_otdel",
    450,
    getColumnSearchProps,
    (a, b) => a.name_otdel?.localeCompare(b.name_otdel)
  ),
  createColumn(
    intl("notes"),
    "Description",
    undefined,
    getColumnSearchProps,
    (a, b) => a.Description?.localeCompare(b.Description)
  ),
  // createColumn(intl("user"), "name_user", 100, getColumnSearchProps, (a, b) =>
  //   a.Name?.localeCompare(b.Name)
  // ),
];
